"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _ossUpload = require("@/utils/ossUpload");
var _customPage = require("@/api/customPage");
var _ActivitySelectionPopup = _interopRequireDefault(require("../../../appRenovation/component/components/ActivitySelectionPopup.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    ActivitySelectionPopup: _ActivitySelectionPopup.default
  },
  data: function data() {
    return {
      id: '',
      dialogVisible: false,
      activityJumpUrl: '',
      ruleForm: {
        image: '',
        jumpType: '',
        openUrl: '',
        activityType: '',
        activityId: '',
        activityTypeName: '',
        activityName: ''
      },
      rules: {
        image: [{
          required: false
        }],
        openUrl: [{
          required: false
        }]
      }
    };
  },
  methods: {
    onSelectEvents: function onSelectEvents(data) {
      console.log(data);
      this.ruleForm.activityName = data.name || data.activityName || data.title;
      this.ruleForm.activityTypeName = data.Display_name;
      this.ruleForm.activityId = data.id || data.pageId;
      this.ruleForm.activityType = data.Display_type;
      this.activityJumpUrl = data.openUrl;
    },
    goAct: function goAct() {
      this.$refs.activitySelectionPopup.open();
    },
    delPic: function delPic() {
      this.ruleForm.image = '';
    },
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context.v;
              // console.log(pictureUrl, '-------------')
              this.ruleForm.image = pictureUrl;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleFileUpload(_x) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    open: function open(data) {
      var _this = this;
      this.id = data.id;
      (0, _customPage.moduleDetail)({
        moduleId: data.id
      }).then(function (res) {
        if (res.data && res.data.goodsActivity != null) {
          _this.ruleForm.image = res.data.marqueeSetting.floatingWindowPic;
          _this.ruleForm.jumpType = res.data.goodsActivity.jumpType;
          if (_this.ruleForm.jumpType === 2) {
            _this.activityJumpUrl = res.data.goodsActivity.openUrl;
          } else {
            _this.ruleForm.openUrl = res.data.goodsActivity.openUrl;
          }
          _this.ruleForm.activityType = res.data.goodsActivity.activityType;
          _this.ruleForm.activityId = res.data.goodsActivity.activityId;
          _this.ruleForm.activityTypeName = res.data.goodsActivity.activityTypeName;
          _this.ruleForm.activityName = res.data.goodsActivity.activityName;
        }
      });
      this.dialogVisible = true;
    },
    onClose: function onClose() {
      this.$refs['ruleForm'].resetFields();
      this.ruleForm.activityType = '';
      this.ruleForm.activityId = '';
      this.ruleForm.activityTypeName = '';
      this.ruleForm.activityName = '';
      this.dialogVisible = false;
    },
    submitForm: function submitForm(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var params = (0, _objectSpread2.default)({}, _this2.ruleForm);
          if (_this2.ruleForm.jumpType === 2) {
            params.openUrl = _this2.activityJumpUrl;
          }
          (0, _customPage.saveOrUpdateBanner)({
            moduleId: _this2.id,
            goodsActivity: params
          }).then(function (res) {
            if (res.data) {
              _this2.$notify.success({
                title: '温馨提示',
                message: '操作成功'
              });

              // this.$emit('refresh', this.type)
              _this2.onClose();
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.ruleForm.openUrl = '';
      this.$refs[formName].resetFields();
    }
  }
};